define('viewmodels/Reporting/Reports',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, ObjGeneralSettings) {
    var ReportViewModel = {
        activate: activate,
        detached: detached,
        attached: attached,
        ReportList: ko.observableArray(),
        HeaderReportList: ko.observableArray(),
        ReportListDup: ko.observableArray(),
        ViewReport: ViewReport,
        SelectedReportName :ko.observable(),
        ShowReportList: ShowReportList,
        OrganisationUnitList: ko.observableArray(),
        OrganisationLevelList: ko.observableArray(),
        OrganisationUnitList_filter: ko.observableArray(),
        AssessmentTypeList: ko.observableArray(),
        AssessmentYearList: ko.observableArray(),
        LanguageList: ko.observableArray(),
        SelectedUnits: ko.observableArray(),
        SelectedAssessmentType: ko.observable(),
        SelectedOrganisationLevel: ko.observable(),
        getOrganisationUnitDropDown: getOrganisationUnitDropDown,
        SelectedOrganisationUnit: ko.observable(),
        ShowDetailedReportPopUp: ShowDetailedReportPopUp,
        DisplayExportDropdown: DisplayExportDropdown,
        AssessmentProfileList: ko.observableArray([]),
        generateReport: generateReport,
        User: ko.observable(),
        BusinessUnitList: ko.observableArray([]),
        DownloadSummaryHardcodedReport: DownloadSummaryHardcodedReport,
        expandCollapseAll: expandCollapseAll,
        ProfileList: ko.observableArray([]),
        GetCurrentYearOfAssessment: GetCurrentYearOfAssessment,
        DownloadReport: DownloadReport,
        addPopUpCss: ko.observable(false),
        OpenDownloadSummaryReportpopup: OpenDownloadSummaryReportpopup,
        popUpTitle: ko.observable(),
        GetAssessmentType: GetAssessmentType,
        AssessmentList: ko.observableArray([]),
        SelectedAssessmentId: ko.observable(),
        SelectedProfileOfAssessment: ko.observable(null),
        ProfileofAssessmentList: ko.observableArray(),
        OrgLvlDrpDwnList: ko.observableArray(),
        OrganisationalLevelList: ko.observableArray(),
        OrgLvlValueList: ko.observableArray(),
        SelectedOrgLevelId: ko.observable([]),
        BusinessUnitsList: ko.observableArray(),
        BuListReport: BuListReport,
        FillOrgLevel: FillOrgLevel,
        SelectedBuUnitsID: ko.observable([]),
        PageHeader: ko.observable('Reports '),
        IsBU: ko.observable(true),
        Overrides_Show: ko.observable(true),
        LocaleCheckFlag: ko.observable(false),
        ObjGeneralSettings: ObjGeneralSettings
    }
    return ReportViewModel;

    var ReportTableObj = false;


    function activate() {
        try {

            if (ReportViewModel.ObjGeneralSettings === undefined || ReportViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ReportViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ReportViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ReportViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                ReportViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (ReportViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ReportViewModel.ObjGeneralSettings.LocalizedTextList() == null || ReportViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ReportViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ReportViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        ReportViewModel.LocaleCheckFlag(false);
                    else
                        ReportViewModel.LocaleCheckFlag(true);
                });
            } else
                ReportViewModel.LocaleCheckFlag(true);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in Reports.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {

            if (ReportViewModel.ObjGeneralSettings === undefined || ReportViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ReportViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ReportViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ReportViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                ReportViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (ReportViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ReportViewModel.ObjGeneralSettings.LocalizedTextList() == null || ReportViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ReportViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ReportViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        ReportViewModel.LocaleCheckFlag(false);
                    else
                        ReportViewModel.LocaleCheckFlag(true);
                });
            }

            ReportViewModel.PageHeader((!ReportViewModel.LocaleCheckFlag() || ReportViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Reports') == -1) ? 'Reports ' : ReportViewModel.ObjGeneralSettings.LocalizedTextList()[ReportViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Reports')].Name());
            //ReportViewModel.PageHeader('Reports ');
            getDetailedReportDropDown();
            $('#BUSelector').multiselect();
            $('#BUSelector').multiselect("refresh");
            getAssessmentProfileDetails();
            GetAllReports();
            GetAllBusinessUnits();
            GetUser();
            GetProfileAssessments().then(function () {
                GetAssessmentType().then(function () {
                    GetOrgLevel().then(function () {
                        //GetAllOrganizationalLevels();
                    });


                });
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in Reports.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(1)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in Reports.js';
            logger.logMessage(msg);
        }
    };

    function ShowReportList() {

        $("#div_DisplayReport").hide();
        $(".div_DisplayBack").hide();
        $("#backbutton").hide();
        $("#expheatmap").show();
        $("#collheatmap").show();
        $("#divReportTable").show();
        $("#DetailedReport").show();
        $("#DownlaodR").show();
        ReportViewModel.SelectedReportName('');
        ReportViewModel.PageHeader('Reports ');
    }

        function DownloadReport(data, event) {
            try {
                var BuId = ReportViewModel.SelectedBuUnitsID();
                var FlagAML = 1;
                if (ReportViewModel.AssessmentList()[0].RiskAssessmentName().toString() === "Sanctions") {
                    FlagAML = 0;
                }
                else {
                    FlagAML = 1;
                }
                var payLoad = {

                    //    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(ReportViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), YOA: ReportViewModel.SelectedProfileOfAssessment(), OrglevelId: ReportViewModel.SelectedOrgLevelId(), AssessmentId: ReportViewModel.SelectedAssessmentId(), ShowOverrides: ReportViewModel.Overrides_Show()
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(ReportViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), SubOrgId: BuId[0], YOA: ReportViewModel.SelectedProfileOfAssessment(), OrglevelId: ReportViewModel.SelectedOrgLevelId(), AssessmentId: ReportViewModel.SelectedAssessmentId(), ShowOverrides: ReportViewModel.Overrides_Show(), SubOrgName: ReportViewModel.SelSubOrgName, SubOrgShortName: ReportViewModel.SelSubOrgShortName
                    , FAML: FlagAML
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadReport() method in Reports.js';
                logger.logMessage(msg);
            }
        }


    function GetOrgLevel() {
        try {
            return $.ajax({
                url: "/api/Configuration/getAllBusinessLevelsDocReport",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { TypeId: ReportViewModel.SelectedProfileOfAssessment() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetOrgLevel() method in Reports.js';
            logger.logMessage(msg);
        }

    function ajaxSuccess(jsonResult, status) {
        try {
            if (jsonResult != null) {
                var OrganizationalLevels = $.map(jsonResult, function (result) {
                    return new OrganisationLevelModelReport(result);
                });
                if (OrganizationalLevels.length > 0) {
                    ReportViewModel.OrganisationalLevelList(OrganizationalLevels);

                    BuListReport();
                    //BindHTML();
                 //   ReportViewModel.OrgLvlValueList(ReportViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                }
                else {
                    //BindHTML();
                }
                //Get all ] list with org sub level id's
                //GetAllBusinessUnitsForFilters();
                //ReportViewModel.SelectedCheckedList([]);
                //ReportViewModel.SelectedCheckedBUList([]);

            }
            else
                logger.logMessage('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ReportViewModel), true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function ajaxFail(error, status) {
        try {
            if (error.status == 401) {
                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
            }
            else {
                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }
    }

    function getAllBusinessUnits() {
        try {
            return $.ajax({
                url: "/api/Reporting/GetAllBusinessUnitsByProfileAssessment?profileId=" + ReportViewModel.SelectedProfileOfAssessment(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in report.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {

                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {

                    ReportViewModel.BusinessUnitsList([]);
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnitsModel(result);
                    });

                    ReportViewModel.BusinessUnitsList(mappedBusinessUnits);

                    $('#BUSelector').multiselect();
                    $('#BUSelector').multiselect("refresh");
                    $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");

                    //$(".ui-multiselect-checkboxes > li > label").addClass("cc-checkbox");
                  //  $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");
                }
                else {
                    app.showMessage("Business Units configurations not in place", "Error", ["OK"]);

                    ReportViewModel.BusinessUnitsList([]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        };
    }
    function BusinessUnitsModel(item) {
        try {
            var self = this;
            self.BlvalueId = ko.observable(item.BU_ID);
            self.BlvalueName = ko.observable($('<div/>').html(item.businessUnitCleanName).text());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in ValidationReports.js';
            logger.logMessage(msg);
        }
    }


    function FillOrgLevel() {
        try {
            GetOrgLevel();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in FillOrgLevel() method in Report.js';
            logger.logMessage(msg);
        }
    }

    function BuListReport() {
        try {
            var mappedBuList = [];
            if (ReportViewModel.SelectedOrgLevelId() == 0) {

                $('#BUSelector').multiselect();
                $('#BUSelector').multiselect("refresh");
                ReportViewModel.IsBU(true);
                ReportViewModel.BusinessUnitsList([]);
                getAllBusinessUnits();

            }
            else {
                ReportViewModel.IsBU(false);
                ReportViewModel.BusinessUnitsList([]);
                GetAllOrganizationalLevels().then(function () {

                    for (var i = 0; i < ReportViewModel.OrgLvlDrpDwnList().length; i++) {
                        if (ReportViewModel.OrgLvlDrpDwnList()[i].BlId() == ReportViewModel.SelectedOrgLevelId()) {
                            for (var j = 0; j < ReportViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                                mappedBuList.push(ReportViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j]);
                            }
                            ReportViewModel.BusinessUnitsList(mappedBuList);
                            break;
                        }
                    }
                });
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in BuListReport() method in Report.js';
            logger.logMessage(msg);
        }
    }
    function RiskAssessmentModel(item) {

        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.RiskAssessmentName = ko.observable($('<div/>').html(item.AssessmentName).text());
            self.RiskAssessmentType = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.RiskAssessmentDescription = ko.observable($('<div/>').html(item.Description).text());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAssessmentModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }

    function GetAllOrganizationalLevels() {
        try {
            return $.ajax({
                url: "/api/Configuration/getDistinctBusinessLevelsAllBUApplicability",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { TypeId: ReportViewModel.SelectedAssessmentId(), YOA: ReportViewModel.SelectedProfileOfAssessment() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in Report.js';
            logger.logMessage(msg);

        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var OrganizationalLevels = $.map(jsonResult, function (result) {
                        return new BusinessLevelsModel(result);
                    });
                    if (OrganizationalLevels.length > 0) {
                        ReportViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                    }
                }
                else
                    logger.logMessage('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ReportViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    }

    function BusinessLevelsModel(item) {
        try {
            var self = this;
            self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
            self.BlName = ko.observable($('<div/>').html(item.BlName).text());
            self.BlId = ko.observable(item.BlId)
            var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                return new BuLevelValueListModel(result);
            });
            self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in Report.js';
            logger.logMessage(msg);
        }
    }


    function BuLevelValueListModel(item) {
        try {
            var self = this;
            self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
            self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
            self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
            self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
            self.TargetRow = ko.observable(item.TargetRow);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in Report.js';
            logger.logMessage(msg);
        }
    }

    function GetProfileAssessments() {
        try {
            return $.ajax({
                url: "/api/Reporting/GetProfileAssessmentData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetProfileAssessments() method in InherentHeatMapAnalysis.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length > 0) {
                    var MappedPeriodofAssessment = $.map(jsonResult, function (result) {
                        return new ProfileofAssessmentModel(result);
                    });
                    ReportViewModel.ProfileofAssessmentList([]);
                    ReportViewModel.ProfileofAssessmentList(MappedPeriodofAssessment);
                }
                else
                    logger.logMessage('An error occurred while fetching the Current Profile of Assessment. Please contact your application administrator.', 'Error', system.getModuleId(YrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetProfileAssessments() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAssessmentProfileDetails() method in YearSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetProfileAssessments() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
    }

    function ProfileofAssessmentModel(item) {
        try {
            var self = this;
            self.ConfigurationFreezeFlag = ko.observable('true');
            self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
            self.Todate = ko.observable($('<div/>').html(item.Todate).text());
            self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
            self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in InherentHeatMapAnalysis.js';
            logger.logMessage(msg);
        }
    }
    function GetAssessmentType() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
            })
                .success(function (jsonResult, error) {
                    var MappedAssessmentModel = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAssessmentModel(result);
                        return RiskAreaModelObj;
                    });
                    ReportViewModel.AssessmentList(MappedAssessmentModel);
                })
                .fail(function (jsonResult, error) { });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in Reports.js';
            logger.logMessage(msg);
        }
    }

    function GetCurrentYearOfAssessment() {
        try {
            return $.ajax({
                url: "/api/Account/GetCurrentProfileAssessmentList",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from GetCurrentYearOfAssessment() method in ValidationReports.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.profileItem.length > 0) {
                    var mappedProfileList = $.map(jsonResult.profileItem, function (item) {
                        return new profileList(item);
                    });
                    VRViewModel.ProfileList(mappedProfileList);
                    var selectedProfile = ko.utils.arrayFilter(VRViewModel.ProfileList(), function (parameter) {
                        return parameter.status() == "A";
                    });
                    if (selectedProfile.length == 1 && selectedProfile)
                        VRViewModel.profileSelected(selectedProfile[0].ID());
                }
                else
                    logger.logMessage('An error occurred while fetching the Current Year of Assessment. Please contact your Administrator', 'Error', system.getModuleId(VRViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetCurrentYearOfAssessment() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from GetCurrentYearOfAssessment() method in ValidationReports.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetCurrentYearOfAssessment() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }
    }

    function OpenDownloadSummaryReportpopup() {
        try {
            $('#frmSummaryReport').modal('show');
            $('#modalContent').css({
                'margin-top': '25%'
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenDownloadSummaryReportpopup() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function ShowDetailedReportPopUp() {
        try {
            $('#frmDetailedReport').modal('show');
            ReportViewModel.SelectedAssessmentType("");
            ReportViewModel.SelectedOrganisationLevel("");
            ReportViewModel.SelectedUnits("");
            getDetailedReportDropDown();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ShowChangePasswordPopUp() method in header.js';
            logger.logMessage(msg);
        }


    }

    function GetAllBusinessUnits() {
        try {
            $.ajax({
                url: "/api/AMLRiskAssessment/GetAllBusinessUnits",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    if (jsonResult != undefined) {
                        if (jsonResult.length != null) {
                            var newbu = new BusinessUnitModel({ BuId: 12, BuName: "EMEA", BuAssessmentDate: "TEST", BuStatus: "APPLICABLE", SubLevelId: 1023 });
                            var mappedBuList = $.map(jsonResult, function (result) {
                                return new BusinessUnitModel(result);
                            });
                            mappedBuList.push(newbu);
                            ReportViewModel.BusinessUnitList(mappedBuList);
                        }
                    }
                })
                .fail(function (error, fail) {

                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getDetailedReportDropDown() method in Reports.js';
                        logger.logMessage(msg);
                    }
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllBusinessUnits() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function getAssessmentProfileDetails() {
        try {
            $.ajax({
                url: "/api/Calculation/GetProfileAssessmentData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    var MappedPeriodofAssessment = $.map(jsonResult, function (result) {
                        return new ProfileofAssessmentModel(result);
                    });
                    ReportViewModel.AssessmentProfileList(MappedPeriodofAssessment);
                })
                .fail(function (error, status) {

                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getDetailedReportDropDown() method in Reports.js';
                        logger.logMessage(msg);
                    }
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getAssessmentProfileDetails() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    // Detailed Report
    function getDetailedReportDropDown() {
        try {
            $.ajax({
                url: "/api/Reporting/getDetailedReportDropDown",
                data: { "OrganisationLevel": null, "Flag": 1 },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
               .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in getDetailedReportDropDown() method in Reports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var AssessmentTypeList = $.map(jsonResult.AssessmentTypeList, function (result) {
                        var AssessmentTypeModelObj = new AssessmentTypeModel(result);
                        return AssessmentTypeModelObj;
                    });
                    ReportViewModel.AssessmentTypeList(AssessmentTypeList);

                    var OrganisationLevelList = $.map(jsonResult.OrganisationLevelList, function (result) {
                        var OrganisationLevelModelObj = new OrganisationLevelModel(result);
                        return OrganisationLevelModelObj;
                    });
                    ReportViewModel.OrganisationLevelList(OrganisationLevelList);

                    var OrganisationLevelUnitList = $.map(jsonResult.OrganisationLevelUnitList, function (result) {
                        var OrganisationLevelUnitModelObj = new OrganisationLevelUnitModel(result);
                        return OrganisationLevelUnitModelObj;
                    });
                    ReportViewModel.OrganisationUnitList(OrganisationLevelUnitList);
                    ReportViewModel.OrganisationUnitList_filter(OrganisationLevelUnitList);
                }
                else {

                    logger.logMessage('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in getDetailedReportDropDown() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {

                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();

                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getDetailedReportDropDown() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getDetailedReportDropDown() method in Reports.js';
                logger.logMessage(msg);
            }
        }
    }
    function getOrganisationUnitDropDown(data, event) {
        try {
            $.ajax({
                url: "/api/Reporting/getDetailedReportDropDown",
                data: { "OrganisationLevel": ReportViewModel.SelectedOrganisationLevel(), "Flag": 2 },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
               .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call in getDetailedReportDropDown() method in Reports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {

                    var OrganisationLevelUnitList = $.map(jsonResult.OrganisationLevelUnitList, function (result) {
                        var OrganisationLevelUnitModelObj = new OrganisationLevelUnitModel(result);
                        return OrganisationLevelUnitModelObj;
                    });
                    ReportViewModel.OrganisationUnitList(OrganisationLevelUnitList);
                    ReportViewModel.OrganisationUnitList_filter(OrganisationLevelUnitList);
                }
                else {

                    logger.logMessage('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in getDetailedReportDropDown() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {

                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();

                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getDetailedReportDropDown() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getDetailedReportDropDown() method in Reports.js';
                logger.logMessage(msg);
            }
        }

    }

    function generateReport() {
        try {
            if (ReportViewModel.SelectedAssessmentType() == '' || ReportViewModel.SelectedAssessmentType() == null) {
                $("#lblErrorMsg").text("Please select an assessment type.");
                return;
            }
            else if (ReportViewModel.SelectedOrganisationLevel() == '' || ReportViewModel.SelectedOrganisationLevel() == null) {
                $("#lblErrorMsg").text("Please select an Organization level.");
                return;
            }
            else if (ReportViewModel.SelectedUnits() == '' || ReportViewModel.SelectedUnits() == null) {
                $("#lblErrorMsg").text("Please select an organization unit.");
                return;
            }
            else {
                $("#lblErrorMsg").text("");
                var units = ReportViewModel.SelectedUnits().join(',');
                var OrganisationLevelName = $("#idOrganisationLevel option:selected").text();
                var AssessmentTypeName = $("#idAssessmentType option:selected").text();
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: ReportViewModel.SelectedAssessmentType(), OrganisationLevel: ReportViewModel.SelectedOrganisationLevel(), OrganisationLevelUnit: units,AssessmentTypeName:AssessmentTypeName,OrganisationLevelName: OrganisationLevelName,
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadDetailedReport", payLoad, '_blank');
            }
        }
        catch (e) {
            var msg = 'Exception' + e + 'source: generateReport() in Reports.js';
            logger.logMessage(e);
        }
    }
    function AssessmentTypeModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable(item.AssessmentId);
            self.AssessmentType = ko.observable(item.AssessmentType);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentTypeModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function OrganisationLevelUnitModel(item) {
        try {
            var self = this;
            self.OrganisationUnitId = ko.observable(item.OrganisationUnitId);
            self.OrganisationUnit = ko.observable(item.OrganisationUnit);
            self.level = ko.observable(item.level);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OrganisationLevelUnitModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }

    function DownloadSummaryHardcodedReport()
    {
        try {
            var payLoad = {
                t: appsecurity.getAuthenticationInfo()
            };
            utils.postAndRedirect(rootPath + "/FileDownload/ExportSummaryReport", payLoad, '_blank');
        }
        catch (e)
        {
            var msg = 'Exception: ' + e + ' | Source: DownloadSummaryHardcodedReport() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function OrganisationLevelModel(item) {
        try {
            var self = this;
            self.OrganisationLevelId = ko.observable(item.OrganisationLevelId);
            self.OrganisationLevel = ko.observable(item.OrganisationLevel);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OrganisationLevelModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }

    function OrganisationLevelModelReport(item) {
        try {
            var self = this;
            self.OrganisationLevelId = ko.observable($('<div/>').html(item.BuLId).text());
         self.OrganisationLevelName = ko.observable($('<div/>').html(item.BuLevelName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OrganisationLevelModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function GetAllReports() {

        try {
            $.ajax({
                url: "/api/Reporting/GetAllReports",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllReports() method in Reports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                $('#loadingMainImgDiv').hide();
                $('#tblReports').show();
                $('#divReportTable').show();
                if (jsonResult != null) {
                    ReportViewModel.ReportList([]);
                    ReportViewModel.HeaderReportList([]);
                    var MappedReportList = $.map(jsonResult.reportHeader, function (result) {
                        return new ReportHeaderModel(result,jsonResult.ssrsReportModel);
                    });
                    ReportViewModel.HeaderReportList(MappedReportList);
                    ReportTableObj = $('#tblReports').DataTable({
                    });
                    $('#tblReports').DataTable().draw(false);
                }
                else
                    logger.logMessage('An error occurred while fetching Roles. Please contact the Administrator.', 'Error', system.getModuleId(RmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllReports() method in Reports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllReports() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllReports() method in Reports.js';
                logger.logMessage(msg);
            }
        };
    }
    function ViewReport(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Reporting/GetReportDetail",
                type: "GET",
                headers: headers,
                data: { ReportId: data.ReportId() }

            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllReports() method in Reports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult.ReportId != -999) {
                    if (jsonResult.ReportCategory == 'D') {
                        ExportDirectlyToExcel(jsonResult);
                    }
                    else {
                        $("#divReportTable").hide();
                        $("#DownlaodR").hide();
                        $('#loadingMainImgDiv').show();
                        ReportViewModel.SelectedReportName(data.DisplayName());
                        setTimeout(function () { ShowReport(data); }, 2000);
                        ShowReport(jsonResult);
                    }
                } else {
                    logger.logError(jsonResult.ReportComments + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(ReportViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllReports() method in Reports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllReports() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllReports() method in Reports.js';
                logger.logMessage(msg);
            }
        };
    }

    function ExportDirectlyToExcel(data) {
        try {
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), ReportName: data.ReportName, ReportDisplayName: data.DisplayName
            };
            utils.postAndRedirect(rootPath + "/FileDownload/ExportDirectlyToExcel", payLoad, '_blank');
        }
        catch (e) {
            var msg = 'exception' + e + 'source in ExportDirectlyToExcel() in Reports.js';
            logger.logMessage(msg);
        }
    }

    function GetUser() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Reporting/GetUser",
                type: "GET",
                headers: headers,

            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in Reports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {

                ReportViewModel.User(jsonResult);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in Reports.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUser() method in Reports.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUser() method in Reports.js';
                logger.logMessage(msg);
            }
        };
    }



    function ShowReport(data) {
        ReportViewModel.PageHeader('Reports: ');
        $('#divReport').html('');
        var homeurl = homeUrlLocation;
        var url = window.location.hash;
        $('<iframe>', {

            src: homeurl + 'ReportsViewer.aspx?ReportName=' + data.ReportName() +  '&UserId=' + ReportViewModel.User(),
            id: 'iframe_FINDINGS',
            frameborder: 0,
            style: 'display: block; width: 100%; height: 1500px; margin-left: 0px;',
        }).appendTo('#divReport');

        $('#loadingMainImgDiv').hide();
        $('#div_DisplayReport').show();
        $('.div_DisplayBack').show();
        $("#backbutton").show();
        $("#expheatmap").hide();
        $("#collheatmap").hide();
        $("#DownlaodR").hide();

    }

    function expandCollapseAll(type, data) {
        if (type == 'E' || type == 'C') {
            ko.utils.arrayForEach(ReportViewModel.HeaderReportList(), function (Param) {
                if (type == 'E') {
                    Param.isReportsVisible(true);
                }
                else {
                    Param.isReportsVisible(false);
                }
            });
        }
    }
    function ReportHeaderModel(item, reportList) {
        var self = this;
        self.HeaderName = ko.observable(item.HeaderName);
        self.isReportsVisible = ko.observable(false);
        self.seeReports = function () {
            if (self.isReportsVisible() == false)
                self.isReportsVisible(true);
            else
                self.isReportsVisible(false);
        };
        var mapReports = $.map(reportList, function (parameter) {
            if (parameter.HeaderName == self.HeaderName())
                return new ReportModel(parameter);
        });
        self.ReportList = ko.observable(mapReports);
    }
    function ReportModel(item) {
            var self = this;
            self.ReportId = ko.observable(item.ReportId);
            self.ReportName = ko.observable($('<div/>').html(item.ReportName).text());
            self.ReportComments = ko.observable($('<div/>').html(item.ReportComments).text());
            self.DisplayName = ko.observable($('<div/>').html(item.DisplayName).text());
            self.ReportCategory = ko.observable($('<div/>').html(item.ReportCategory).text());
            self.Dataset = ko.observable(item.Dataset);

    }

    function ProfileofAssessmentModel(item) {
        try {
            var self = this;
            self.ConfigurationFreezeFlag = ko.observable('true');
            self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
            self.Todate = ko.observable($('<div/>').html(item.Todate).text());
            self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
            self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in Reports.js';
            logger.logMessage(msg);
        }
    }
    function BusinessUnitModel(item) {
        try {
            var self = this;
            self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
            self.BuName = ko.observable($('<div/>').html(item.BuName).text());
            self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
            self.SubLevelId = ko.observable(item.SubLevelId);
            self.isChecked = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
        }
        function DisplayExportDropdown(data, event) {

            document.getElementById("ReportLinkDiv").classList.toggle("show");
            document.getElementById("ReportLinkDivBtn").classList.toggle("open");
        }

});
